module.exports = __webpack_public_path__ + "img/taken.ce7bea78.svg";